import React, { useState } from 'react';
import Fuse from 'fuse.js';

import './FuzzyLookup.scss';
import { AutoComplete } from '../AutoComplete/AutoComplete';

const DEFAULT_RESULTS_SHOWN = 10;

interface Props {
  id: string;
  value: string;
  items: string[];
  onChange: (value: string) => void;
  label: string;
  errorMessage: string | boolean;
  placeholder: string;
  clearLabel: string;

  noResultsMessage: JSX.Element;
  maxResultsShown?: number;
}

export const FuzzyLookup = (props: Props) => {
  const {
    id,
    items,
    label,
    onChange,
    value,
    errorMessage,
    placeholder,
    clearLabel,
    maxResultsShown = DEFAULT_RESULTS_SHOWN,
    noResultsMessage,
  } = props;

  const [results, setResults] = useState<string[]>([]);
  const fuse = new Fuse(items);

  const fuseSearch = (val: string) => {
    const fuseResults = fuse.search(val).map((fuseResult) => fuseResult.item);
    setResults(fuseResults.slice(0, maxResultsShown));
  };

  return (
    <div className="FuzzyLookup">
      <div className="FuzzyLookup-autocomplete">
        <AutoComplete
          id={id}
          items={results}
          label={label}
          onInputValueChange={(val) => fuseSearch(val)}
          onSelect={(val) => onChange(val)}
          placeholder={placeholder}
          selectedItem={value}
          clearLabel={clearLabel}
          isLoading={false}
          error={errorMessage}
          noResultsMessage={noResultsMessage}
        />
      </div>
    </div>
  );
};
